import { useMutation, useQueryClient } from "react-query";
import { useToast } from "@chakra-ui/react";
import { t } from "i18next";
import { TData, TPayload } from "./types";
import { translations } from "../../../i18n/translations";
import { postCreateManifest } from "./postCreateManifest";
import { Queries } from "../../../constants/queries";
import { TDumpingLogs } from "../DumpingLogs/types";

export const useCreateManifest = () => {
  const toast = useToast();
  const queryClient = useQueryClient();
  return useMutation<TData, unknown, TPayload>(
    (payload) => postCreateManifest(payload),
    {
      onError: () => {
        toast({
          title: "Error",
          description: t<string>(translations.errors.cancel_job_error),
          status: "error",
          position: "top-right",
        });
      },
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries([Queries.Manifests(variables.companyId)]);

        queryClient.setQueryData(
          [Queries.Manifests(variables.companyId)],
          (oldData: TDumpingLogs | undefined) => ({
            ...oldData,
            companyDumpingLogs: [...(oldData?.companyDumpingLogs || []), data],
          })
        );
      },
    }
  );
};
